import { render, staticRenderFns } from "./EstaimesDetailsComponent.vue?vue&type=template&id=631d1293&scoped=true&"
import script from "./EstaimesDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./EstaimesDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./EstaimesDetailsComponent.vue?vue&type=style&index=0&id=631d1293&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631d1293",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VListItem,VRow,VSelect,VTextField})
